<div class="download-dialog">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  
  <mat-dialog-content>
    <div class="success-container">
      <mat-icon class="success-icon mb-3" color="primary">content_paste_go</mat-icon>
      <p class="success-message">Documento pronto per il download</p>
    </div>

    <p>{{ data.message }}</p>
    
    <!-- Style Selector -->
    <div class="style-selector">
      <mat-form-field appearance="outline" class="w-100 mt-2">
        <mat-label>Seleziona stile PDF</mat-label>
        <mat-select [(value)]="selectedStyle">
          <mat-option value="style1">
            <span class="circle green"></span>
            Stile 1 - Semplice
          </mat-option>
          <mat-option value="style2">
            <span class="circle blue"></span>
            Stile 2 - Moderno
          </mat-option>
          <mat-option value="style3">
            <span class="circle purple"></span>
            Stile 3 - Raffinato
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button 
      mat-button 
      (click)="closeDialog()"
      class="close-button">
      Chiudi
    </button>

    <button 
      mat-raised-button 
      color="primary" 
      (click)="downloadPdf()"
      class="download-button">
      <mat-icon>download</mat-icon>
      Scarica PDF
    </button>
  </mat-dialog-actions>
</div>
